import * as angular from 'angular';

export interface CapacityLinkingResource extends ng.resource.IResourceClass<
    ng.resource.IResource<any>
> {
    report: ng.resource.IResourceMethod<ng.resource.IResource<any>>;
}

function capacityLinkingResource(
    $resource: ng.resource.IResourceService,
    API_URL
): CapacityLinkingResource {
    return <CapacityLinkingResource>$resource(
        API_URL.CAPACITY_LINKING,
        {},
        {
            report: {
                method: 'GET',
                url: API_URL.CAPACITY_LINKING + '/report'
            }
        }
    );
}

angular
    .module('app')
    .factory('capacityLinkingResource', capacityLinkingResource);
